import React, { useEffect } from "react";
import { ReactComponent as ResourceIcon } from "../../../assets/icons/modal/resource.svg";
import DefaultModal from "../DefaultModal/DefaultModal";
import AddResourcesForm from "../forms/AddResourcesForm/AddResourcesForm";
import ModalTitle from "../ModalTitle/ModalTitle";
import styles from "./styles.module.scss";

interface Props {
  onClose: () => void;
  onApply: () => void;
}

const AddResourceModal: React.FC<Props> = (props) => {
  const onApply = () => {
    props.onApply();
    props.onClose();
  };

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        props.onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.onClose]);

  return (
    <DefaultModal>
      <div className={styles.container}>
        <ModalTitle
          onClose={props.onClose}
          title="Основна інформація"
          subTitle="Створіть нову запчастину. Заповніть основні дані."
          isLittleMargin={true}
        >
          <ResourceIcon />
        </ModalTitle>
        <AddResourcesForm onClose={props.onClose} onApply={onApply} />
      </div>
    </DefaultModal>
  );
};

export default AddResourceModal;
